module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/motivosRechazo/motivosRechazo.component.scss
// module id = ./src/app/cliente/motivosRechazo/motivosRechazo.component.scss
// module chunks = main